import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import DataTable from '../../../components/DataTable/DataTable';
import { Button } from '@material-ui/core';
import DeleteConfirm from '../../../components/DataTable/DeleteConfirm';
import ResponseDialog from './ResponseDialog';
import { approvementTypeLabelKey } from './approvement-type.helper';
import IpaasService from '../../../services/IpaasService/IpaasService';
import BotService from '../../../services/BotService/BotService';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, rolePermission } from '../../../recoil-store/recoil-state';

let deletedRequest = { id: '', bot_type: '' };
const useStyles = makeStyles(theme => ({
    button: {
        textTransform: 'none',
    }
}));

/**
 * @Description This function lets you return component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function MyBots(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { open, fetchData, setOpen, customColumn, setCustomColumn, searchData, loading, setSearchKeyData } = props;
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const label = 'CONTENT.PUBLISH-APPROVE.';
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);

    const handleDelete = (item) => {
        setOpenDelete(true);
        if (props.type === 'bot') {
            deletedRequest = {
                id: item.approvement_id,
                bot_type: item.bot_type
            };
        }
        // else {
        //     deletedRequest = item.integration_approvements_id;
        // }
    }

    const deleteRequest = async () => {

        setLoadingDelete(true);
        let response = { status: true };
        if (deletedRequest.id) {
            if (props.type === 'bot') {
                response = await BotService.deletePublishRequest(deletedRequest);
            }
            // else {
            //     let id = deletedRequest;
            //     response = await IpaasService.deletePublishRequest(id);
            // }
        }
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t(label + 'AUTOMATION-APPROVEMENT-' + response.message), severity: response.status ? 'success' : 'error' }))
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        fetchData(0);
        setLoadingDelete(false);
    };

    useEffect(() => {
        const column = [{
            id: 5,
            name: '',
            label: ' ',
            options: { filter: false, sort: false }
        }, {
            id: 0,
            name: props.type === 'bot' ? 'approvement_id' : 'integration_approvements_id',
            label: ' ',
            options: {
                filter: false, sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                }
            }
        }, {
            id: 1,
            name: 'bot_type',
            label: t(label + 'BOT-TYPE'),
            options: {
                filter: true, sort: true,
                // AR-7737: service catalog requests are labelled "Service"; approve/reject still sends bot_type 'autom'.
                customBodyRenderLite: (dataIndex) => {
                    const row = searchData && searchData[dataIndex];
                    if (!row) {
                        return null;
                    }
                    const key = approvementTypeLabelKey(row);
                    return <span data-testid="approvement-type">{key ? t(key) : row.bot_type}</span>;
                }
            }
        }, {
            id: 2,
            name: 'name',
            label: t(label + 'NAME'),
            options: { filter: true, sort: true }
        }, {
            id: 3,
            name: 'version',
            label: t(label + 'VERSION'),
            options: { filter: true, sort: true }
        }, {
            id: 4,
            name: 'status',
            label: t(label + 'STATUS'),
            options: { filter: true, sort: false }
        }, {
            id: 5,
            name: 'published_by_fullname',
            label: t(label + 'PUBLISHED-BY'),
            options: { filter: true, sort: true }
        }, {
            id: 6,
            name: 'actions',
            label: t(label + 'ACTIONS'),
            options: {
                filter: false, sort: false, display: permissions?.data.includes('CONNECTION_UPDATE') ? true : 'excluded',
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return (
                            <div>
                                {searchData[dataIndex].status === 'CANCELED' || searchData[dataIndex].status === 'APPROVED' ? <>
                                    <Button className={classes.button} color="secondary" onClick={() => { handleDelete(searchData[dataIndex]) }}>
                                        {t(label + 'DELETE')}
                                    </Button>
                                    {!searchData[dataIndex].status == 'APPROVED' && <Button className={classes.button} color="primary" onClick={() => { setOpen({ open: true, bot: searchData[dataIndex], type: 'reactive' }) }}>
                                        {t(label + 'REACTIVE')}
                                    </Button>}</> :
                                    <Button disabled={open.open} color="primary" className={classes.button} onClick={() => { setOpen({ open: true, bot: searchData[dataIndex], type: 'cancel' }) }}>
                                        {t(label + 'CANCEL')}
                                    </Button>
                                }
                            </div>
                        );
                    }
                }
            }
        }];
        setCustomColumn(column)
        setSearchKeyData(['bot_type', 'name', 'status', 'published_by_fullname']);
    }, [t, searchData]);

    return (
        <div data-test="credential-tab">
            <DataTable
                customColumns={customColumn}
                selectableRows={'none'}
                data={searchData}
                title={t(label + 'CREDENTIAL-LIST')}
                loading={loading}
                loadingDelete={loadingDelete}
            />
            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t(label + 'DELETE-WARNING')} deleteFunc={deleteRequest} />}
            {open.open && <ResponseDialog setOpen={setOpen} open={open} fetchData={fetchData} tabIndex={0} type={props.type} />}
        </div>
    );
}

export default MyBots;
